module.exports = "pegasus/assets/active-row-border-bottom.png";